<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-08-26 15:46:47
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-09-03 19:09:17
 * @FilePath: /goldenSalesMobile/src/views/CommisionWithdraw/index.vue
 * @Description: 
-->
<template>
  <div class="page-container">
    <nav-bar title="提现" />
    <div class="withdrawInfo-wrap">
      <div class="progress-bar">
        <span>
          <svg-icon iconClass="process1" widthSize="22px" heightSize="22px" />
        </span>
        <span>
          <svg-icon iconClass="process2" widthSize="22px" heightSize="22px" />
        </span>
        <span>
          <svg-icon iconClass="process3" widthSize="22px" heightSize="22px" />
        </span>
      </div>
      <ul class="withdraw-info">
        <li>
          <span>提现金额</span>
          <span>￥{{ withdrawableAmount }}</span>
        </li>
        <li>
          <span @click="onShowTipDialog"
            >增值税<svg-icon iconClass="wenhao"
          /></span>
          <span>￥{{ vat }}</span>
        </li>
        <li>
          <span>实际到账金额</span>
          <span class="arrival-amount">￥{{ arrivalAmount }}</span>
        </li>
      </ul>
    </div>
    <p class="tips-title">提现方式</p>
    <p class="tips">实时到账，提现到微信-钱包-零钱，最低提现金额100元</p>
    <van-button
      round
      block
      color="linear-gradient(to right, #FA9B00, #FBCA39)"
      @click="onWithdraw"
    >
      确认提现
    </van-button>
  </div>
</template>

<script>
import { postCommisionWithdraw } from "@/api/system";

export default {
  props: ["withdrawableAmount"],

  data() {
    return {
      vat: 0,
      arrivalAmount: 0,
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.vat = (this.withdrawableAmount * 0.06).toFixed(2);
      this.arrivalAmount = (
        Number(this.withdrawableAmount) - Number(this.vat)
      ).toFixed(2);
    },

    onShowTipDialog() {
      this.$dialog.alert({
        confirmButtonColor: "#CCA567",
        title: "提示",
        message: "劳务报酬所得应缴纳个人所得税，金贵公司为您代扣代缴税金",
      });
    },

    onWithdraw() {
      if (Number(this.arrivalAmount) < 100) {
        this.$toast("最低提现金额100元");
        return;
      }

      postCommisionWithdraw({
        Fee: Number((this.arrivalAmount * 100).toFixed(2)),
      }).then((res) => {
        if (res.IsSuccess) {
          this.$router.push({
            name: "Result",
            params: {
              type: "withdraw",
              status: "success",
              id: "null",
            },
          });
        } else {
          sessionStorage.setItem("failReason", res.Message);
          this.$router.push({
            name: "Result",
            params: {
              type: "withdraw",
              status: "fail",
              id: "null",
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  @include border-box(0 40px);
  width: 100%;
  height: 100vh;
  background: #ffffff;

  .withdrawInfo-wrap {
    @include flex-box(flex-start, center);
    width: 100%;
    margin: 78px auto 60px;

    .progress-bar {
      @include flex-box(flex-start, center);
      flex-direction: column;
      width: 44px;
      margin-right: 20px;

      > span {
        position: relative;
        width: 100%;
        height: 44px;
        margin-bottom: 116px;

        &:not(:last-child)::after {
          position: absolute;
          bottom: -116px;
          left: 50%;
          z-index: 1;
          content: "";
          width: 1px;
          height: 116px;
          background: #fdda7d;
        }
      }
    }

    .withdraw-info {
      @include flex-box(flex-start, flex-start);
      flex-direction: column;

      > li {
        @include flex-box(flex-start, flex-start);
        flex-direction: column;

        > span:first-child {
          line-height: 40px;
          font-size: 28px;
          color: #888888;
          margin-bottom: 18px;
        }

        > span:last-child {
          line-height: 60px;
          font-size: 52px;
          font-weight: 500;
          color: #333333;
          margin-bottom: 42px;

          &.arrival-amount {
            line-height: 70px;
            font-size: 60px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            background: linear-gradient(
              270deg,
              rgba(251, 202, 57, 1) 0%,
              rgba(250, 155, 0, 1) 100%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
  }

  .tips-title {
    margin-bottom: 10px;
    line-height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #888888;
  }

  .tips {
    margin-bottom: 60px;
    line-height: 42px;
    font-size: 30px;
    font-weight: 500;
    color: #030303;
  }

  &::v-deep .van-button {
    font-size: 18px;
    font-weight: 600;
    margin-top: 80px;
    box-shadow: 0px 4px 20px 0px rgba(255, 200, 99, 1);
  }
}
</style>
